import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineProductLinesSelect from '../inputs/InlineProductLinesSelect';


class NumberOfOrdersRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      count: initialValues.count || 2,
      product_line_ids: initialValues.product_line_ids || [],
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'product_lines',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { count, product_line_ids, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          value={regions}
          onChange={val => this.setState({ regions: val })}
        />
        <InlineInputNumber
          label='Count Allowed'
          description='Amount of different items allowed to be purchased in a product line'
          value={count}
          onChange={value => this.setState({ count: value })}
          min={1}
        />
        <InlineProductLinesSelect
          value={product_line_ids}
          onChange={val => this.setState({ product_line_ids: val })}
        />
      </RuleForm>
    );
  }
}

NumberOfOrdersRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

NumberOfOrdersRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default NumberOfOrdersRule;
